import { SvgIcon, SvgIconProps } from "@mui/material";

export function ManualGearIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M8,5 L4,5 L4,2 L8,2 L8,5 M4,22 L8,22 L8,19 L4,19 L4,22 M14,2 L10,2 L10,5 L14,5 L14,2 M10,22 L14,22 L14,19 L10,19 L10,22 M16,2 L16,5 L20,5 L20,2 L16,2 M17,11 L13,11 L13,7 L11,7 L11,11 L7,11 L7,7 L5,7 L5,17 L7,17 L7,13 L11,13 L11,17 L13,17 L13,13 L19,13 L19,7 L17,7 L17,11 Z" />
    </SvgIcon>
  );
}
